import { useEffect } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import afip from "../../assets/logo_afip.png";
import renaper from "../../assets/renaper.png";
import anses from "../../assets/anses.png";
import miargentina from "../../assets/mi-argentina.jpeg";
import "./auth.scss";

function Auth({ data }) {
    var location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const dataEnc = params.get("data");

    useEffect(() => {
        let dataParse = false;
        if (params && dataEnc) {
            dataParse = JSON.parse(window.atob(dataEnc));
            if (dataParse && dataParse.idrafam) {
                localStorage.setItem("data", JSON.stringify(dataParse));
                return navigate('/transporte', { replace: true });
            }
            if (dataParse && dataParse.idrafam === "0") {
                localStorage.setItem("data", JSON.stringify(dataParse));
                return navigate('/nuevo-contribuyente', { replace: true });
            }
        }
        if (data && data.idrafam) {
            localStorage.setItem("data", JSON.stringify(data));
            return navigate('/transporte', { replace: true });
        }
        if (data && data.idrafam === "0") {
            localStorage.setItem("data", JSON.stringify(data));
            return navigate('/nuevo-contribuyente', { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    //const urlredirectdev = "http://localhost:3000";
    const urlredirectprod = "https://transportes-escolares-sn.netlify.app";

    const authRenaper = () => {
        window.location.replace(
            `${process.env.REACT_APP_AUTH_URL}?ret=rctrenaper&vuelve=${urlredirectprod}`
        )
    };
    const authAnses = () => {
        window.location.replace(
            `${process.env.REACT_APP_AUTH_URL}?ret=rctanses&vuelve=${urlredirectprod}`
        );
    };
    const authAfip = () => {
        window.location.replace(
            `${process.env.REACT_APP_AUTH_URL}?ret=rctafip&vuelve=${urlredirectprod}`
        );
    };
    const authMiArgentina = () => {
        window.location.replace(
            `${process.env.REACT_APP_AUTH_URL}?ret=rctmiarg&vuelve=${urlredirectprod}`
        );
    };

    return (
        <div className="auth-container" >
            <div className='login-user'>
                <h3 className='mb-2 text-secondary'> INICIA SESIÓN</h3>{' '}
                <p
                    style={{
                        maxWidth: '500px',
                        textAlign: 'center',
                        textTransform: 'uppercase',
                        fontSize: '14px',
                    }}
                    className='mb-5 text-secondary'
                >
                    Para solicitar o Adjuntar un comprobante de pago, debes iniciar sesión
                    con uno de estos servicios
                </p>
                <Button
                    onClick={authAfip}
                    style={{ width: '200px' }}
                    variant='primary'
                    className='p-2 mb-4'
                >
                    AFIP
                </Button>
                <Button
                    onClick={authAnses}
                    style={{ width: '200px' }}
                    variant='primary'
                    className='p-2  mb-4'
                >
                    ANSES
                </Button>
                <Button
                    onClick={authRenaper}
                    style={{ width: '200px' }}
                    variant='primary'
                    className='p-2  mb-4'
                >
                    RENAPER
                </Button>
                <Button
                    onClick={authMiArgentina}
                    style={{ width: '200px' }}
                    variant='primary'
                    className='p-2 mb-4'
                >
                    MI ARGENTINA
                </Button>
            </div>
        </div>

    );
}

export default Auth;

